import { createApp } from 'vue'
import Auth from './components/Auth.vue'

createApp(Auth).mount('#auth')
